import React from 'react';
import { Container, ContentContainer, ContentRow, Title, Description, } from './styles';
import { Building } from 'src/assets/Images';
import { BUILDING, ADDRESS, APARTMENTS_QUANTITY, } from 'src/Utils/constants';
var renderInformation = function (header, information) { return (React.createElement(ContentRow, null,
    React.createElement(Description, { className: "size" },
        header,
        ":"),
    React.createElement(Description, { className: "bold" }, information))); };
var AdminCard = function (_a) {
    var _b = _a.data, name = _b.name, id = _b.id, address = _b.address, quantity_of_apartments = _b.quantity_of_apartments;
    return (React.createElement(Container, { className: "admin" },
        React.createElement(Title, { className: "admin" }, BUILDING),
        React.createElement(ContentContainer, { className: "admin" },
            React.createElement(ContentRow, { className: "header" },
                React.createElement("img", { src: Building }),
                React.createElement(Title, { className: "card-title" }, name)),
            renderInformation(ADDRESS, address),
            renderInformation(APARTMENTS_QUANTITY, quantity_of_apartments))));
};
export default AdminCard;
